export default __webpack_public_path__ + "static/media/006-elephant.d504fee4.svg";